const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export const registerServiceWorker = () => {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return;
  }

  window.addEventListener('load', () => {
    const publicUrl = process.env.PUBLIC_URL || '';
    const swUrl = `${publicUrl}/service-worker.js`;

    if (isLocalhost) {
      checkValidServiceWorker(swUrl);
      return;
    }

    navigator.serviceWorker.register(swUrl).catch(() => {
      // The app still works online if service worker registration fails.
    });
  });
};

export const requestOfflineQueueReplay = () => {
  if (!navigator.serviceWorker?.controller) {
    return;
  }

  navigator.serviceWorker.controller.postMessage({
    type: 'POSEIDON_REPLAY_QUEUE',
  });
};

const checkValidServiceWorker = (swUrl: string) => {
  fetch(swUrl, {
    headers: { 'Cache-Control': 'no-store' },
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');

      if (response.status === 404 || (contentType && contentType.indexOf('javascript') === -1)) {
        navigator.serviceWorker.ready
          .then((registration) => registration.unregister())
          .then(() => window.location.reload());
      } else {
        navigator.serviceWorker.register(swUrl);
      }
    })
    .catch(() => {
      // Local offline development can still render from the browser cache.
    });
};
